// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","navLink":"Navbar_navLink__6hnmd"};